<template>
    <div id="Temporary">

        <Head />

        <div class="hotspot clear">
            <Nav ms="/Temporary" />

            <div v-if="tabClick == 0" class="H-right">
                <div class="title1">我的暂存成果</div>
                <div class="H-header">
                    <div class="t-left">
                        <div class="select">
                            <!-- <select v-model="year" @change="getData">
                 <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
              </select> -->
                            <el-date-picker v-model="year" type="year" @change="getData" :default-value="value"
                                value-format="yyyy" :picker-options="pickerOptions" placeholder="请选择" :clearable="false">
                            </el-date-picker>
                            <el-input placeholder="请输入成果名称" remote="true" v-model="keyword"></el-input>
                        </div>
                        <div class="btn1" @click="excel()">
                            <i></i>
                            导出数据
                        </div>
                    </div>
                </div>
                <div class="t_main">
                    <el-table border :header-cell-style="{
                        'background-color': '#001743',
                        color: '#fff',
                        height: '0.5rem',
                    }" :stripe="true" :data="tableData1" style="width: 100%; max-height: 95%"
                        :row-style="{ height: '0.4rem' }" @selection-change="handleSelectionChange">
                        <el-table-column :key="Math.random()" min-width="5" width="50" type="index" label="编号"
                            header-align="center" align="center"></el-table-column>
                        <el-table-column :key="Math.random()" min-width="20" prop="Title" label="成果名称" header-align="center"
                            align="center"></el-table-column>
                        <el-table-column :key="Math.random()" min-width="18" prop="Classname" label="分类"
                            header-align="center" align="center">
                            <template slot-scope="s">
                                <ul>
                                    <li>{{ s.row.ParentClassName }}</li>
                                    <li>{{ s.row.Classname }}</li>
                                </ul>
                            </template>
                        </el-table-column>
                        <el-table-column :key="Math.random()" min-width="15" prop="companyname" label="所属单位"
                            header-align="center" align="center"></el-table-column>
                        <el-table-column :key="Math.random()" min-width="10" prop="DeclarTime" label="申报时间"
                            header-align="center" align="center"></el-table-column>
                        <el-table-column :key="Math.random()" min-width="10" prop="Phone" label="手机号" header-align="center"
                            align="center"></el-table-column>

                        <el-table-column min-width="10" label="操作" width="140" :key="Math.random()" header-align="center"
                            align="center">
                            <template slot-scope="scope">
                                <div class="btns">
                                    <el-button size="small" style="background: #2d65d2; color: #ffffff"
                                        @click="tabchange('1', scope.row)">查看</el-button>
                                    <el-button size="small" style="background: #f76423; color: #ffffff"
                                        @click="tabchange2('1', scope.row)">撤销</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination style="text-align: right; height: 0.45rem" v-if="tableData1.length > 0"
                        @current-change="CurrentChange1" @size-change="handleSizeChange1" :current-page="Page1"
                        :page-size="PageSize1" :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper"
                        :total="total1"></el-pagination>
                    <div class="Popup" v-show="isPopup">
                        <div class="none" @click="Popups(0)"></div>
                        <div v-show="isPopup" class="a_forms">
                            <div class="f-top">
                                <i class="el-dialog__close el-icon el-icon-close" @click="Popups(0)"></i>分配专家
                            </div>
                            <div class="f-info">
                                <div class="p-info">
                                    <div>
                                        <span>项目分组：</span>
                                        <select v-model="addExpertReport">
                                            <option value>请选择组</option>
                                            <option v-for="(item, index) in Groups" :value="item.GroupID" :key="index">
                                                {{ item.GroupName }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="f-bottom">
                                    <el-button @click="isPopup = false">取 消</el-button>
                                    <el-button type="primary" @click="exportSubmit()">确 定</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="tabClick == 1" class="H-right">
                <div class="title1">成果审核管理</div>
                <div class="btn btnmini" style="margin-bottom: 0.2rem" @click="tabchange(0)">
                    返回
                </div>

                <div class="info">
                    <div>
                        成果名称：
                        <b>{{ user.Title }}</b>
                    </div>
                    <div>
                        申报单位：
                        <b>{{ user.companyname }}</b>
                    </div>
                    <div class="left-button">
                        <p>成果报告申请表:</p>
                        <!-- <span class="span1" @click="tabchange(2,0,1)">预览</span> -->
                        <div class="lastBtn">
                            <el-button type="primary" style="width: 1rem" @click="tabchange(2, 0, 1)">预览</el-button>
                            <el-button style="width: 1rem; background: rgb(243, 37, 47); color: #fff"
                                @click="dowCg(1)">下载</el-button>
                        </div>
                    </div>
                    <div class="left-button">
                        <p>成果主报告:</p>
                        <!-- <span class="span2" @click="tabchange(2,0,2)">预览</span> -->
                        <div class="sendBtn">
                            <el-button type="primary" style="width: 1rem" @click="tabchange(2, 0, 2)">预览</el-button>
                            <el-button style="width: 1rem; background: rgb(243, 37, 47); color: #fff"
                                @click="dowCg(2)">下载</el-button>
                        </div>
                    </div>
                    <div>
                        <p>成果附件:</p>
                        <div>
                            <el-button style="
                  width: 1rem;
                  background: rgb(243, 37, 47);
                  color: #fff;
                  margin-left: 1.15rem;
                " @click="tabchange(2, 0, 3)">下载</el-button>
                        </div>
                        <!-- <span>无</span> -->
                    </div>
                    <div>
                        <p>成果进度:</p>
                        <div>
                            <el-button style="width: 1rem; margin-left: 1.15rem" type="success"
                                @click="getJd(user.ID)">进度</el-button>
                        </div>
                    </div>
                </div>
                <div class="jieguo">
                    <i></i>
                    <span class="jieguospan">查重结果:</span>
                    <span v-if="baogao.wordRepetitionRate" class="repetition">{{ percentage }}相似</span>

                    <a @click="tabchange(2, 0, 4)" style="color: #2d65d2">点击查看</a>
                </div>
                <div class="yijian">
                    <div>
                        <div></div>
                        <span>审核意见：</span>
                    </div>
                    <div v-if="S != 1 && ideas" class="opinion">{{ ideas }}</div>
                    <textarea name id cols="30" rows="10" v-model="comment" v-if="S == 1"></textarea>
                </div>
                <div class="sub" v-if="S == 1">
                    <div class="btn" @click="submit(2)">通过</div>
                    <div class="btn" style="margin-left: 0.5rem; background: #d93838" @click="submit(3)">
                        不通过
                    </div>
                    <div class="btn" style="margin-left: 0.5rem; background: #f76423" @click="submit(7)">
                        暂存
                    </div>
                </div>
            </div>
            <div v-if="tabClick == 2" class="H-right">
                <div class="btn btnmini" style="margin-bottom: 0.2rem; position: fixed" @click="tabchange(1)">
                    返回
                </div>
                <Preview v-if="lookStatus == 1" :yulan="yulan" :CompanyID="user.CompanyID" />
                <!-- <iframe id='bbb' v-show="lookStatus==2" width=1000  name=hrong height=1000 frameborder="0"></iframe>
          
        <iframe id='aaa' v-show="lookStatus==3" width=1000 name=hrong height=1000 frameborder="0"></iframe>-->
                <FullPreview v-if="lookStatus == 2" :zbg="user.ID" />
                <iframe v-if="lookStatus == 4" width="1000" style="width: 100%" height="1000" frameborder="0"
                    :src="baogaoUrl"></iframe>
            </div>
            <Specificationone ref="child" v-if="tabClick == 3" @child-quit="tabchange(0)" :CompanyID="user.CompanyID">
            </Specificationone>
        </div>
        <el-dialog v-if="jindu.length > 0" title="成果进度" :visible.sync="dialogVisible" :destroy-on-close="true" center
            top="20vh" width="70%" style="font-size: 0.2rem">
            <el-steps v-if="jindu.length > 0" :active="active" direction="vertical" align-center>
                <el-step :title="item.zt" v-for="(item, i) in jindu" :key="i">
                    <template slot="description">
                        <div class="content">
                            <div>
                                <span>{{ item.datetime }}</span>
                                <div>{{ item.companyName }}</div>
                                <div v-if="item.comment" class="contentMsg">
                                    <p style="font-weight: 700; height: 0.3rem">审核意见：</p>
                                    <div class="opinion">{{ item.comment }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-step>
                <el-step :title="end.zt" v-if="end.time">
                    <template slot="description">
                        <span>{{ end.time }}</span>
                        <p>{{ end.nextcompanyName }}</p>
                    </template>
                </el-step>
            </el-steps>
        </el-dialog>
        <Foot></Foot>
    </div>
</template>

<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import Preview from "@/views/Declare/Preview";
import FullPreview from "../Declare/FullPreview";
export default {
    data() {
        return {
            value1: "1",
            tabClick: 0,
            total: 1,
            date: "",
            lookStatus: "",
            addExpertReport: "",
            lssss: [],
            comment: "", // 意见
            yulan: "",
            lx: "0",
            tableData1: [],
            tableData2: [],
            contentInfo: "",
            options: [],
            cgzbg: "",
            Page1: 1,
            svalue: 2,
            PageSize1: 30,
            isPopup: false,
            isZhuanjia: false,
            Idvalue: "",
            reportstatus: 7,
            fpstatus: "",
            infoForm: {
                Title: "",
                Details: "",
                Date: "",
                Type: "1",
                Status: 0,
                FileCode: "",
            },
            baogaoUrl: "",
            baogao: "",
            oldForm: {
                Title: "",
                Details: "",
                Date: "",
                Type: "1",
                Status: 0,
                FileCode: "",
            },
            zbgdata: [], //主报告数据
            showall: "",
            fj: "",
            sbb: "",
            cgzbg1: "",
            ReportIDS: "", //批量操作
            major1: [],
            major2: [],
            major1Value: "", //一级专业
            major2Value: "", //二级专业
            batchArr: [],
            user: {},
            percentage: "", //重复率
            jindu: [],
            useRsubmit: {
                time: "",
                zt: "",
                comment: "",
            },
            end: {
                time: "",
                nextcompanyName: "",
                zt: "",
            },
            dialogVisible: false,
            active: "",
            S: "",
            ideas: "", //审核意见
            dialogVisible1: false,
            Groups: [],
            dialogFormVisible: false,
            lists: [],
            dialogVisible2: false,
            keyword: "",
            show: false,
            show1: false,
            showTable: false,
            fun: null,
            year: new Date().getFullYear().toString(), //element组件默认值为String，传数字会读取不出来
            pickerOptions: {
                // 禁选今日之后的时间,time是当前时间选择器的显示内容
                disabledDate(time) {
                    const date = new Date(); //获取当前时间信息
                    const year = date.getFullYear(); //获取当前年份
                    const timeYear = time.getFullYear(); //获取时间选择器的所有年份
                    // 2020之前与今年之后的全部禁用
                    return timeYear < 2020 ? timeYear < 2020 : timeYear > year;
                },
            },
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        CurrentChange1(val) {
            this.Page1 = val;
            this.getData();
        },
        handleSizeChange1(val) {
            this.PageSize1 = val;
            this.getData();
        },
        dowCg(i) {
            if (i == 1) {
                window.location.href = this.sbb;
            } else {
                window.location.href = this.zgzbg1;
            }
        },
        getJd(id) {
            let that = this;
            // console.log(row)
            // console.log(id)
            for (let key in that.end) {
                that.end[key] = "";
            }
            this.$axios
                .post(
                    "flow/flowtimeline",
                    this.$qs.stringify({
                        ReportID: id,
                        token: sessionStorage.getItem("token"),
                    })
                )
                .then((res) => {
                    console.log(res.data.data);
                    that.jindu = [];
                    if (res.data.code == 10000) {
                        that.jindu = res.data.data;
                        if (this.jindu.length > 0) {
                            this.dialogVisible = true;
                            console.log(this.jindu);
                            that.useRsubmit.time = this.jindu[0].datetime;
                            that.useRsubmit.zt = "已提交";
                            that.jindu.forEach(function (val, index) {
                                // if(val.operation==)
                                console.log(val);
                                switch (val.operation) {
                                    case "1":
                                        val.zt = "待审核";
                                        break;
                                    case "2":
                                        val.zt = "审核通过";
                                        break;
                                    case "3":
                                        val.zt = "审核未通过";
                                        break;
                                    case "4":
                                        val.zt = "待评分";
                                        break;
                                }
                                that.jindu[0].companyName = "";
                                that.jindu[0].zt = "已提交";
                                if (val.companyName == val.nextcompanyName && val.operation == 1) {
                                    val.zt = "提交成果";
                                    val.companyName = "";
                                }
                                if (index == that.jindu.length - 1 && val.sysmsg == "审核通过！" && val.operator != 1) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.sysmsg == "审核通过！" && val.operator == 1) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待评分";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.companyName == "") {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }

                                if (
                                    index == that.jindu.length - 1 &&
                                    val.operation == 3 &&
                                    val.companyID != val.nextcompanyID
                                ) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "待审核";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.operation == 7) {
                                    that.end.time = that.jindu[index].datetime;
                                    that.end.zt = "暂存";
                                    that.end.nextcompanyName = val.nextcompanyName;
                                }
                                if (index == that.jindu.length - 1 && val.sysmsg === null && val.operation != 1) {
                                    // that.end.time = that.jindu[index].datetime;
                                    // that.end.zt = "待评分";
                                    // that.end.nextcompanyName ="";
                                    for (let key in that.end) {
                                        that.end[key] = "";
                                    }
                                }

                                if (val.sysmsg == "审核通过！" && val.companyName == "中国煤炭工业协会") {
                                    that.jindu = that.jindu.slice(0, index + 1);
                                }
                                if (that.jindu.length == 0) {
                                    that.active = 1;
                                } else {
                                    that.active = that.jindu.length;
                                }
                            });
                        } else {
                            this.$message({
                                type: "warning",
                                message: "暂无进度信息",
                            });
                        }
                    } else if (res.data.code == 10002) {
                        this.$message({
                            type: "warning",
                            message: res.data.msg,
                        });
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
        },
        tabchange2(arr, arr2) {
            let that = this;
            this.$confirm("确认操作, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                // console.log(e,arr)
                // console.log("fjkdagjasg",arr2);
                that.$axios
                    .post(
                        "report/updatestatus?token=" + sessionStorage.getItem("token"),
                        that.$qs.stringify({
                            ID: arr2.ID,
                            Status: "1",
                        })
                    )
                    .then((res) => {
                        if (res.data.code == 10000) {
                            this.$message({
                                type: "success",
                                message: res.data.msg,
                            });
                            this.getData();
                        } else {
                            this.$message({
                                type: "warning",
                                message: res.data.msg,
                            });
                        }
                        // console.log(res);
                    });
            });
        },
        tabchange(a, b, c) {
            if (c != 3) {
                this.tabClick = a;
            }

            if (this.lx == 0) {
                if (b) {
                    this.user = b;
                    // this.getBaogao()
                    if (a == 3) {
                        this.$nextTick(() => {
                            this.$refs.child.showTable = false;
                        });
                    } else {
                        this.getReportcontent(); //获取文件地址
                        this.getBaogao();
                    }

                    //this.getReview();
                }
            } else {
                this.Popups(1);
            }
            if (a == 1 && b) {
                this.user = b;
                console.log(b);
                this.$axios
                    .post(
                        "flow/flowtimeline",
                        this.$qs.stringify({
                            ReportID: this.user.ID,
                            token: sessionStorage.getItem("token"),
                        })
                    )
                    .then((res) => {
                        if (res.data.code == 10000) {
                            console.log(res.data.data, 44444444);
                            // var val = res.data.data[res.data.data.length - 1];
                            // console.log(val);
                            // if (
                            //   val.sysmsg == "审核通过！" &&
                            //   val.companyName == "中国煤炭工业协会"
                            // ) {
                            //   this.c = val.comment;
                            //   console.log(this.c, 4);
                            // }
                            res.data.data.forEach((val) => {
                                if (val.operation == "2" && val.companyName == "中国煤炭工业协会") {
                                    this.ideas = val.comment;
                                    console.log(this.c, 4);
                                }
                            });
                        } else if (res.data.code == 10002) {
                            this.$message({
                                type: "warning",
                                message: res.data.msg,
                            });
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
                this.getReportcontent(); //获取文件地址
                this.getBaogao();
            }
            if (c) {
                this.lookStatus = c;
            }

            console.log(this.contentInfo.Content, 1111);
            if (c == 3) {
                if (this.fj) {
                    window.location.href = this.fj;
                } else {
                    this.$message({
                        message: "暂无附件信息",
                        type: "warning",
                    });
                }
            }
        },
        Popups(e = 0, f) {
            console.log(e, f);
            if (e == 1) {
                this.infoForm = f;
            }

            this.isPopup = !this.isPopup;
        },
        excel() {
            window.location.href = this.$URL + "/excel/reports_save?token=" + sessionStorage.getItem("token");
        },
        getData() {
            let that = this;
            that.$axios
                .post(
                    "report/index?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        Status: this.reportstatus,
                        page: this.Page1,
                        num: this.PageSize1,
                        ClassifyID: this.major2Value,
                        keyword: this.keyword,
                        year: this.year,
                    })
                )
                .then((res) => {
                    // console.log()
                    if (res.data.code == 10000) {
                        var list = res.data.data.list;

                        var st = (this.Page1 - 1) * this.PageSize1;
                        this.tableData1 = list.slice(this.Page1 == 1 ? 0 : st, this.PageSize1 * this.Page1);
                        this.tableData1.forEach((val) => {
                            val.DeclarTime = val.DeclarTime.split(" ")[0];
                            this.S = val.Status;
                            console.log(this.S);
                        });
                        this.total1 = res.data.data.total_num;
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        getBaogao() {
            var that = this;
            that.$axios
                .post(
                    "check/ccresult?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ID,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res, "报告");
                        if (res.data.data[0]) {
                            // console.log(res.data.data[0].Result)
                            if (!res.data.data[0].ResultLink) {
                                this.baogaoUrl = res.data.data[0].Result;
                            } else {
                                this.baogaoUrl = res.data.data[0].ResultLink;
                            }

                            this.baogao = res.data.data[0];
                            this.percentage = (res.data.data[0].wordRepetitionRate * 100).toFixed(2);
                        }
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        getReportcontent() {
            var that = this;
            that.$axios
                .post(
                    "word/sbb?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ID,
                    })
                )
                .then((res) => {
                    console.log(res.data.data, "sbb");
                    if (res.data.code == 10000) {
                        this.sbb = res.data.data;
                    }
                });
            that.$axios
                .post(
                    "word/words",
                    that.$qs.stringify({
                        token: sessionStorage.getItem("token"),
                        ReportID: that.user.ID,
                    })
                )
                .then((res) => {
                    this.zgzbg1 = res.data.data;
                });
            that.$axios
                .post(
                    "reportcontent/info?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ID,
                        MouldID: this.user.MouldID,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res.data.data, "报告");
                        this.contentInfo = res.data.data;
                        this.yulan = JSON.stringify(this.contentInfo);
                        this.contentInfo.forEach((el) => {
                            if (el.Title == "cgzbg") {
                                //按顺序写入数组
                                this.cgzbg = el.Content;
                            }
                            if (el.Title == "fj1") {
                                //按顺序写入数组
                                this.fj = el.Content;
                            }
                        });
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
    },
    watch: {
        keyword: function () {
            this.Page1 = 1;
            this.getData();
        },
    },
    components: {
        Head,
        Foot,
        Nav,
        Preview,
        FullPreview,
    },
};
</script>
<style lang="less">
#Temporary {
    .Specification {
        .H-right {
            float: none;
        }
    }

    .t-left {
        .el-input__inner {
            font-size: 0.16rem;
            width: 2rem;
            height: 0.4rem;
            line-height: 0.4rem;
        }
    }

    .el-dialog__header {
        text-align: center;
    }

    .el-card:hover {
        border: 1px solid lightblue;
    }

    .el-dialog {
        .el-dialog__title {
            font-size: 0.2rem;
            font-weight: 400;
        }

        .el-step__head.is-process {
            color: #c0c4cc;
            border-color: #c0c4cc;
        }

        .el-step__title.is-finish {
            color: #303133;
        }

        .el-step__title.is-process {
            font-weight: normal;
        }

        .el-step__description.is-finish {
            color: #303133;

            .content {
                display: flex;

                .opinion {
                    text-indent: 2em;
                }
            }

            p {
                width: 1.6rem;
                height: 0.5rem;
            }
        }

        .watch {
            margin-top: 0.3rem;
            border-top: 1px solid #aaa;
            padding-top: 0.16rem;
            color: #333;

            p {
                font-size: 0.18rem;
                margin-bottom: 0.16rem;
                font-weight: bold;
            }

            div {
                text-indent: 2em;
                line-height: 2;
            }
        }
    }
}
</style>
<style lang="less" scoped>
.btns {
    display: flex;
    justify-content: center;
}

.time {
    position: relative;

    .time-select {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }
}

.clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}

.btn {
    width: 4.6rem;
    cursor: pointer;
    height: 0.58rem;
    line-height: 0.58rem;
    font-size: 0.17rem;
    text-align: center;
    background: #2d65d2;
    color: #fff;
}

.btnchange {
    background-color: #f2f2f4;
    color: #000000;
}

.btnmini {
    width: 1rem;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.05rem;
}

.hotspot {
    width: 100%;
    min-width: 1000px;
    font-size: 0.16rem;
    padding: 0.28rem 1rem 0 2.54rem;
    box-sizing: border-box;

    .H-right {
        position: relative;
        width: 13rem;
        min-width: 750px;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        min-height: 7.4rem;
        border-left: 1px #eeeeee solid;

        // .left-button {
        //   display: flex;
        //   .lastBtn {
        //     margin-left: 0.6rem;
        //   }
        // }
        .title1 {
            font-size: 0.4rem;
            margin: 0.2rem 0 0.5rem;
            text-align: center;
        }

        .btnselect {
            display: flex;
        }

        .H-header {
            .t-left {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 0.5rem;
                position: relative;

                .select {
                    display: flex;
                    width: 80%;
                }

                .btn1 {
                    background: rgb(247, 100, 35);
                    width: 1.5rem;
                    height: 0.4rem;
                    color: #fff;
                    border-radius: 0.05rem;
                    text-align: center;
                    line-height: 0.4rem;
                    display: flex;
                    position: absolute;
                    right: -0.1rem;
                    cursor: pointer;
                    top: 0.05rem;
                    z-index: 10;
                    justify-content: space-around;
                    align-items: center;
                    padding: 0 0.15rem;

                    i {
                        // margin: 0.07rem 0.2rem 0 0.2rem;
                        width: 0.28rem;
                        height: 0.28rem;
                        background-image: url("../../assets/back/Excel.png");
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        // background-size: 50%  100%;
                    }
                }

                >span,
                select,
                div,
                input {
                    margin-right: 0.2rem;
                    width: 2rem;
                    height: 0.4rem;
                }

                input {
                    padding: 0.05rem;
                }
            }

            .t-right {
                float: right;
            }
        }

        .t_main {
            .table {
                .list {
                    width: 100%;
                    display: flex;
                    padding-bottom: 0.2rem;
                    align-items: center;
                    position: relative;
                    border-bottom: 1px #d9d9d9 solid;

                    &:hover {
                        background: #f0f0f0;
                    }

                    .btn {
                        position: absolute;
                        top: 0.2rem;
                        right: 0.2rem;
                    }

                    .l-right {
                        width: 3.14rem;
                        height: 1.56rem;
                        position: relative;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .l-info {
                        flex: 1;
                        // padding-left: 0.3rem;
                        font-size: 0.16rem;
                        color: #4e4e4e;
                        height: 100%;

                        .l-info-name {
                            span {
                                font-size: 0.2rem;
                                font-weight: bold;
                                color: #171717;
                                line-height: 0.5rem;
                            }

                            i {
                                font-style: normal;
                                background: #ff0a0a;
                                color: #ffffff;
                                display: inline-block;
                                font-size: 0.14rem;
                                margin-left: 0.2rem;
                                height: 0.19rem;
                                text-align: center;
                                border-radius: 0.04rem;
                            }
                        }

                        .l-info-text {
                            height: 0.5rem;
                            margin-bottom: 0.1rem;
                        }

                        .l-info-time {
                            margin-right: 0.2rem;
                            margin-bottom: 0.1rem;
                        }

                        .l-info-text {
                            span {
                                float: left;
                                font-weight: 800;
                                margin-right: 0.2rem;
                                line-height: 0.25rem;
                            }

                            div {
                                margin-left: 0.4rem;
                                line-height: 0.25rem;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 3;
                                overflow: hidden;
                            }
                        }
                    }
                }
            }
        }

        // .l-main{
        //   .list{
        //     display: flex;
        //     // justify-content: space-around;
        //     align-items: center;
        //     border-bottom: 1px #d9d9d9 solid;
        //     padding: 0.2rem 0;
        //     .content{
        //       flex: 1;
        //       .content-name{
        //         margin-bottom: 0.15rem;
        //         span{
        //           font-size: .2rem;
        //           font-weight: bold;
        //           // line-height: 2.5;
        //         }
        //       }
        //       .content-group{
        //         margin: 0.1rem 0;
        //       }
        //     }
        //     .btn{
        //       align-self: start;
        //       // margin-top: 0.2rem;
        //     }
        //   }
        // }
        .info {
            padding: 0.3rem;
            border: 1px #d0d0d0 solid;
            margin-bottom: 0.3rem;

            >div {
                height: 0.7rem;
                display: flex;

                p {
                    width: 2rem;
                }
            }

            .span1 {
                margin-left: 0.4rem;
            }

            .span2 {
                margin-left: 0.7rem;
            }

            .span3 {
                margin-left: 0.85rem;
            }

            span {
                display: inline-block;
                color: white;
                width: 1rem;
                text-align: center;
                line-height: 0.5rem;
                height: 0.5rem;
                cursor: pointer;
                background: #2d65d2;
                border-radius: 0.1rem;
            }

            // > div:nth-of-type(5) {
            //   display: flex;
            //   span {
            //     display: inline-block;
            //     width: 2.2rem;
            //   }
            //   div {
            //     margin: 0;
            //     margin-top: 0.1rem;
            //   }
            // }
            >div {

                // margin:0.5rem 0 ;
                // > div {
                //   margin-left: 0.9rem;
                //   line-height: 0.26rem;
                // }
                >span {
                    // float: left;
                    line-height: 0.5rem;
                }

                .upload {
                    cursor: pointer;
                    width: 10rem;
                    padding-left: 0.5rem;
                    background: url(../../assets/back/18.png) left center no-repeat;
                }
            }
        }

        .title {
            margin: 0.5rem 0;
            font-size: 0.18rem;
            font-family: Microsoft YaHei;

            >input {
                float: right;
                height: 0.35rem;
                margin-right: 50%;
                padding: 0.05rem;
            }

            >div {
                display: flex;
                height: 0.35rem;
                align-items: center;

                >div {
                    height: 0.05rem;
                    width: 0.05rem;
                    border-radius: 50%;
                    background: #2d65d2;
                    margin-right: 0.2rem;
                }
            }
        }

        .jieguo {
            font-size: 0.18rem;
            font-weight: bold;
            margin: 0.5rem 0;
            display: flex;
            align-items: center;

            .repetition {
                width: 1.1rem;
                height: 0.4rem;
                background: #ff0000;
                border-radius: 0.05rem;
                color: #fff;
                text-align: center;
                line-height: 0.4rem;
            }

            .jieguospan {
                color: #1c1c1c;
                margin-left: 0.05rem;
            }

            // line-height: 100%;
            // height: .4rem;
            i {
                display: inline-block;
                width: 0.35rem;
                height: 0.35rem;
                background-image: url("../../assets/back/serach.png");
                background-size: 80%;
                background-repeat: no-repeat;
                background-position: 100% 100%;
                margin-right: 0.05rem;
            }

            span {
                color: #d93838;
                margin-right: 0.2rem;
            }

            a {
                font-weight: 400;
                text-decoration: underline;
                cursor: pointer;
            }
        }

        .yijian {
            div:first-of-type {
                display: flex;
                height: 0.35rem;
                align-items: center;

                >div {
                    height: 0.05rem;
                    width: 0.05rem;
                    border-radius: 50%;
                    background: #2d65d2;
                    margin-right: 0.2rem;
                }
            }

            textarea {
                position: relative;
                top: -0.35rem;
                left: 1.1rem;
                width: 80%;
            }

            .opinion {
                // width: 60%;
                border: 1px solid #ccc;
                padding: 0.1rem;
                margin: 0.15rem 0;
            }
        }

        .sub {
            width: 100%;
            display: flex;
            justify-content: center;

            div {
                border-radius: 0.1rem;
            }
        }
    }
}

.block {
    .el-card__body {
        .head {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;

            img {
                width: 0.4rem;
            }

            h4 {
                margin: 0 0.1rem;
            }

            div {
                margin-left: 0.2rem;
                font-size: 0.14rem;

                span {
                    margin-right: 0.2rem;
                }
            }
        }

        .content {
            div {
                margin-bottom: 0.2rem;
            }

            div:last-of-type {
                margin-bottom: 0;
            }

            .score {
                span {
                    margin-right: 0.3rem;
                }
            }

            .yj {
                display: flex;

                span {
                    width: 8%;
                }

                div {
                    width: 90%;
                    // text-indent: 2em;
                }
            }

            .contentMsg {
                position: relative;
                padding-left: 10px;
            }

            .contentMsg ::before {
                content: "";
                background-color: #3796EC;
                width: 3px;
                height: .45rem;
                position: absolute;
                left: 0;
                top: 10%;
                // margin-top: -9px;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                border-radius: 3px;
            }
        }
    }
}

.Popup {
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .none {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .a_forms {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 7rem;
        //height: 6rem;
        background: white;
        font-size: 0.16rem;

        .f-top {
            height: 0.3rem;
            width: 100%;
            text-align: center;
            line-height: 0.5rem;
            position: relative;

            // border-bottom: 1px #cfcfcf solid;
            .el-icon-close {
                width: 0.5rem;
                height: 0.5rem;
                position: absolute;
                right: 0.1rem;
                top: 0.1rem;
                cursor: pointer;
            }

            div {
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 0;
                height: 0.5rem;
                width: 0.5rem;
                background: url("../../assets/back/x.png") center center no-repeat;
            }
        }

        .f-info {
            padding: 0.2rem 0.68rem 0;

            .p-info {
                >.p-input {
                    align-items: center;
                }

                >.upimg {
                    align-items: center;
                    justify-content: space-between;
                }

                >div {
                    margin: 0.2rem 0;
                    display: flex;

                    >.p-time {
                        position: relative;
                        flex: 1;
                        margin: 0 0.2rem;

                        >input {
                            width: 100%;
                            padding: 0.05rem;
                            height: 0.3rem;
                            border: 1px #cccccc solid;
                        }

                        .p-select {
                            width: 100%;
                            top: 0;
                            left: 0;
                            opacity: 0;
                            position: absolute;
                        }

                        .icon {
                            position: absolute;
                            top: 0;
                            right: 0;
                            height: 0.3rem;
                            width: 0.3rem;
                            background: url("../../assets/back/time.png") center center no-repeat;
                        }
                    }

                    >input,
                    select {
                        flex: 1;
                        padding: 0.05rem;
                        margin: 0 0.2rem;
                        height: 0.4rem;
                        border: 1px #cccccc solid;
                    }

                    >textarea {
                        flex: 1;
                        padding: 0.05rem;
                        margin: 0 0.2rem;
                        border: 1px #cccccc solid;
                    }

                    i {
                        font-style: normal;
                        color: #ff0d0d;
                    }
                }
            }

            .f-bottom {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding: 0.5rem 0;
            }
        }
    }
}
</style>
